<div class="bg-body text-body py-5" data-bs-theme="dark">
  <div class="container">
    <div class="row justify-content-center gx-sm-5 gy-5">

      <!-- - - - About Us - - - -->
      <div class="d-flex flex-column gap-3 col-10 col-sm-12 col-md-10 col-lg-4 col-xl-4">
        <img class="logo mb-3" alt="logo" height="60" src="/icons/logo-white.svg" i18n-alt>
        <p class="text-center" i18n>İyiliğin Peşinde, Hakikatin İzinde<br>Mazluma Umut Ol, Geleceğe Işık Ver!</p>

        <div class="d-flex flex-wrap gap-3 justify-content-between small">
          <a class="icon-link text-decoration-none text-body-emphasis" href="https://www.facebook.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Facebook page" i18n-aria-label>
            <fa-icon [icon]="['fab', 'facebook']" [size]="'lg'" />
            <span>Facebook</span>
          </a>
          <a class="icon-link text-decoration-none text-body-emphasis" href="https://www.instagram.com/hakikatev" rel="noopener noreferrer" target="_blank" aria-label="Instagram page" i18n-aria-label>
            <fa-icon [icon]="['fab', 'instagram']" [size]="'lg'" />
            <span>Instagram</span>
          </a>
          <a class="icon-link text-decoration-none text-body-emphasis" href="https://www.tiktok.com/@hakikatev" rel="noopener noreferrer" target="_blank" aria-label="TikTok page" i18n-aria-label>
            <fa-icon [icon]="['fab', 'tiktok']" [size]="'lg'" />
            <span>TikTok</span>
          </a>
        </div>
      </div>

      <!-- - - - Contact Information - - - -->
      <div class="d-flex flex-column gap-3 col-10 col-sm-7 col-md-6 col-lg-5 col-xl-4">
        <h6 class="fw-bolder ls-4 text-body-emphasis text-uppercase" i18n>İletişim Bilgileri</h6>
        <p>
          <strong>Hakikat Sozial Kultur Bildung e.V.</strong><br>
          Nordendstraße 38-40<br>
          64546 Mörfelden-Walldorf<br>
          Deutschland
        </p>

        <div class="d-flex flex-wrap gap-3 small">
          <a class="icon-link text-decoration-none" href="tel:" aria-label="Contact Phone Number" i18n-aria-label>
            <fa-icon class="text-primary-emphasis" [icon]="faPhone" />
            <span class="text-body-emphasis">+49 6105 - 717 6116</span>
          </a>
          <a class="icon-link text-decoration-none" href="mailto:" aria-label="Contact Email Address" i18n-aria-label>
            <fa-icon class="text-primary-emphasis" [icon]="faEnvelope" />
            <span class="text-body-emphasis">info&#64;hakikatev.com</span>
          </a>
        </div>
      </div>
      
      <div class="d-flex flex-column gap-3 col-10 col-sm-5 col-md-4 col-lg-3 col-xl-4">
        <h6 class="fw-bolder ls-4 text-body-emphasis text-uppercase" i18n>Hızlı Bağlantılar</h6>

        <div class="list-group list-group-flush small">
          <a class="list-group-item" href="#">
            <fa-icon class="me-3" [icon]="faAngleRight" [size]="'sm'" />
            <span i18n>Hakkımızda</span>
          </a>
          <a class="list-group-item" href="#">
            <fa-icon class="me-3" [icon]="faAngleRight" [size]="'sm'" />
            <span i18n>Hakikat'e Katıl</span>
          </a>
          <a class="list-group-item" href="#">
            <fa-icon class="me-3" [icon]="faAngleRight" [size]="'sm'" />
            <span i18n>Faaliyet Alanlarımız</span>
          </a>
          <a class="list-group-item" href="#">
            <fa-icon class="me-3" [icon]="faAngleRight" [size]="'sm'" />
            <span i18n>Sıkça Sorulan Sorular</span>
          </a>
        </div>
      </div> 
    </div>
  </div>
</div>